module.exports = __webpack_public_path__ + "../resources/img/ic_re_calendar3_default.2601d7be.svg";